import { ExternalLink } from '../../Clickables/ExternalLink/ExternalLink';
import { Text } from '../../Text/Text';

export const CancellationText = ({ className = '' }: { className?: string }) => {
  return (
    <div className={`mt-4 mb-6 flex text-center ${className}`}>
      <Text variant="sm" className="m-0">
        Recurring billing,{' '}
        <ExternalLink
          href="https://fishbrainhelp.zendesk.com/hc/en-us/articles/22539074583836-How-do-I-cancel-my-Web-subscription"
          variant="textNone"
          target="_blank"
          className="underline"
        >
          cancel
        </ExternalLink>{' '}
        anytime
      </Text>
    </div>
  );
};
